import React, { useState } from 'react';

/** Campo de contraseña con el "ojo" para verla. Es el mismo <input> de
 *  siempre (acepta las mismas props, incluidos className y style), envuelto
 *  para poner el botón encima. Existe porque escribir una contraseña a ciegas
 *  en el celular es la forma más común de equivocarse al crearla. */
type Props = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  /** Color del ojo; por omisión hereda el del texto de alrededor. */
  colorOjo?: string;
};

const Ojo: React.FC<{ tachado: boolean }> = ({ tachado }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M2 12s3.5-6.5 10-6.5S22 12 22 12s-3.5 6.5-10 6.5S2 12 2 12Z" />
    <circle cx="12" cy="12" r="3" />
    {tachado && <path d="M4 4l16 16" />}
  </svg>
);

const ClaveInput: React.FC<Props> = ({ style, colorOjo, ...rest }) => {
  const [ver, setVer] = useState(false);
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input
        {...rest}
        type={ver ? 'text' : 'password'}
        style={{ ...(style || {}), width: '100%', boxSizing: 'border-box', paddingRight: 44 }}
      />
      <button
        type="button"
        onClick={() => setVer((v) => !v)}
        aria-label={ver ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        title={ver ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        tabIndex={-1}
        style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: 4, lineHeight: 0, color: colorOjo || 'inherit', opacity: 0.7 }}
      >
        <Ojo tachado={ver} />
      </button>
    </div>
  );
};

export default ClaveInput;
